export default __webpack_public_path__ + "static/tiles_top_tablet@2x-3271d8d474b06f56005d42d3db1890f1.png";